// BUILD-042 — Unified employee workspace. Honest placeholder for an approved-design destination
// that does not have a real backend yet (decision: "Future sections remain meaningful
// Planned/Preview; mock saves never claim real persistence" / "No new backend features...").
// Replaces HrAdminTab's prior single catch-all "planned" section — each not-yet-built
// destination now gets its OWN nav entry (matching the full 16-section map) rather than being
// collapsed into one combined bucket, while still being just as honest about not being real.
import { useNavigate } from 'react-router-dom';
import { labelFor, type SectionKey } from './sectionGroups';
import { LOCAL_PREVIEW_ENABLED } from '../localPreviewFlag';

export function PlannedSection({ sectionKey, employeeId }: { sectionKey: SectionKey; employeeId?: string }) {
  const navigate = useNavigate();
  const label = labelFor(sectionKey);
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 text-sm text-gray-500">
      <p className="mb-2">
        {label} is part of the approved full HR design but does not have a real backend in this increment.
      </p>
      {LOCAL_PREVIEW_ENABLED && employeeId && (
        <p>
          An independent demo of the screen map (retired from approval use, and NOT the deployable interface) is at{' '}
          <button type="button" onClick={() => navigate(`/hr/preview/employees/${employeeId}`)} className="text-[#4AABDE] hover:underline">
            the local synthetic preview
          </button>{' '}— it is clearly marked synthetic and never writes real data.
        </p>
      )}
    </div>
  );
}
